import {SiteConfigContextValue} from '@common/core/settings/site-config-context';
import {message} from '@common/i18n/message';
import {User} from '@common/auth/user';
import {slugifyString} from '@common/utils/string/slugify-string';

function getUserProfileLink(user: User): string {
  return `/user/${user.id}/${slugifyString(user.display_name)}`;
}

export const SiteConfig: Partial<SiteConfigContextValue> = {
  homepage: {
    options: [{label: message('Landing page'), value: 'landingPage'}],
  },
  auth: {
    redirectUri: '/',
    adminRedirectUri: '/admin',
    getUserProfileLink,
  },
};
